import {useEffect} from 'react'
import {Html5Qrcode} from 'html5-qrcode'
import {isIOS, isMobile} from 'react-lf-tools'

import {general as textsGeneral} from '../../translate/Translate.jsx'
import {CloseRounded, QrCodeRounded} from "@mui/icons-material";

import './scan.scss'

let html5QrCode

const Scan = ({onResult, onError, onCancel}) => {

    const cameraIdOrConfig = isMobile() ? {facingMode: 'environment'} : {facingMode: 'user'}
    const configuration = {fps: 100, qrbox: {width: 200, height: 200}, aspectRatio: 1.0}

    const qrCodeSucessCallback = (decodedText, decodedResult) => {
        try {
            html5QrCode.stop()
        } finally {
            onResult(decodedResult.result)
        }
    }

    const qrCodeErrorCallback = (errorMessage) => {
        console.log(errorMessage)
    }

    const qrCodeCatch = (err) => {
        try {
            html5QrCode.stop()
        } finally {
            onError(err)
        }
    }

    const handleCloseScan = () => cancel()

    const cancel = () => {
        try {
            html5QrCode.stop()
        } finally {
            onCancel()
        }
    }

    const initScan = () => {
        html5QrCode = new Html5Qrcode('reader')
        if (!html5QrCode.isScanning) {
            html5QrCode
                .start(cameraIdOrConfig, configuration, qrCodeSucessCallback, qrCodeErrorCallback)
                .catch(qrCodeCatch)
        }
    }

    const checkPermission = () => {
        Html5Qrcode.getCameras()
            .then(devices => {
                if (devices && !!devices.length) initScan()
            })
            .catch(err => {
                if (isIOS()) {
                    console.log('Permission denied IOS', err)
                } else {
                    console.log('Permission denied', err)
                }
            })
    }

    useEffect(() => {
        checkPermission()
    }, [])

    return <div className={'scan'}>
        <div className={'top'}>
            <CloseRounded color={'icon'} onClick={handleCloseScan}/>
        </div>
        <div className={'center'}>
            <label className={'label'}>
                {textsGeneral.scanQrCode}
            </label>
            <div id={'reader'}/>
        </div>
        <div className={'bottom'}>
            <QrCodeRounded color={'icon'}/>
        </div>
    </div>
}

export default Scan
